import classNames from "classnames";
import { useUpdateStorageValue } from "../../../../app/state/storageObjectSlice/hook/use-update-storage-value";
import { AddButton } from "../../../../common/Components/Buttons/AddButton";
import { RenameObjectInput } from "../../../../common/RenameObjectInput";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { useSkillsUpdater } from "../../hooks/use-skills-updater";
import { setSkillValue } from "../../redux/slice";
import { MetadataField } from "./MetadataField";
import { SkillField } from "./SkillField";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const SkillsMain = () => {
  const { saveValue } = useUpdateStorageValue("skills", setSkillValue);
  const {
    draftValues,
    errorInput,
    handlePaste,
    handleBeforeInput,
    handleChangeInput,
    handleUpdateSkill,
    handleAddNewField,
    handleDeleteField,
    handleConfirm,
    handleSkillFriendlyNameChange,
  } = useSkillsUpdater(saveValue);
  const { selectedObject } = useStorageSelectors("skills");

  return (
    <div
      className={classNames(
        styles["main-layout"],
        !selectedObject?.write && styles.disabled,
      )}
    >
      <AppUnderlinedTitle
        leftContent={
          <RenameObjectInput
            service={"skills"}
            inputType={"input"}
            handleChangeName={handleSkillFriendlyNameChange}
          />
        }
      >
        <AddButton
          typeBtn={"text_btn"}
          onClick={() => handleAddNewField("parent")}
        />
      </AppUnderlinedTitle>
      <div className={styles["skill-fields-container"]}>
        {draftValues.map((skill) => {
          if (!skill?.parent) {
            return (
              <SkillField
                error={errorInput}
                key={skill.id}
                skill={skill}
                handleBeforeInput={handleBeforeInput}
                handlePaste={handlePaste}
                onChange={(e) => handleChangeInput(e, skill.id)}
                onBlur={() => handleUpdateSkill(skill.id)}
              />
            );
          }
          return (
            <MetadataField
              field={skill}
              key={skill.id}
              onChange={handleChangeInput}
              onDelete={handleDeleteField}
              handleConfirm={handleConfirm}
            />
          );
        })}
      </div>
    </div>
  );
};
